// Empty-workflow screen: drop files to create sources.
import { Upload } from "antd";
import { FileUp, Sparkles } from "lucide-react";

const StartScreen = ({ onAddFiles }) => {
  return (
    <div className="flex h-full items-center justify-center overflow-y-auto bg-[radial-gradient(#cbd5e1_1px,transparent_1px)] [background-size:20px_20px] p-6">
      <div className="w-full max-w-2xl space-y-5">
        <h2 className="text-center text-2xl font-semibold text-gray-800">What do you want to build?</h2>

        <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm space-y-3">
          <Upload.Dragger
            multiple
            accept=".csv,.xlsx,.txt"
            showUploadList={false}
            beforeUpload={(file, list) => {
              // Called once per file; hand over the whole selection on the first call.
              if (file === list[0]) onAddFiles(list);
              return false;
            }}
          >
            <div className="flex flex-col items-center gap-1 py-2">
              <FileUp size={28} className="text-teal-700" />
              <div className="text-sm font-medium text-gray-700">Drop your input files here, or click to choose</div>
              <div className="text-xs text-gray-500">CSV or Excel · each file becomes Source 1, Source 2, … (pick a different sheet in its settings)</div>
            </div>
          </Upload.Dragger>
          <div className="rounded-lg border border-gray-200 p-2">
            <textarea
              disabled
              rows={2}
              placeholder="Describe the output you need, e.g. “Combine these, drop refunds, total each freelancer per week”"
              className="w-full resize-none bg-transparent text-sm outline-none placeholder:text-gray-400"
            />
            <div className="flex items-center justify-between text-[11px] text-gray-400">
              <span className="flex items-center gap-1">
                <Sparkles size={12} /> AI building is coming soon. For now, add steps yourself.
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default StartScreen;
